import React from 'react';
import Views from './views'

function App() {
  return (
    <Views />
  );
}

export default App;